import { render, staticRenderFns } from "./PosProductList.vue?vue&type=template&id=04f4995e&lang=html&"
import script from "./PosProductList.vue?vue&type=script&lang=js&"
export * from "./PosProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports